import React from 'react';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';

import { If } from 'utils';
import { useToggleMap } from 'utils/hooks';
import { PageErrorUi, UiKit } from 'components';
import {
  Table,
  TableHead,
  TableSection,
  TableLoader,
  TableRows,
  TableZeroState
} from 'components/Tables';
import Header from './Header';
import ZeroState from './ZeroState';
import ExceptionEntityTableRows from '../ExceptionEntityTableRows';

const DEFAULT_RENDER = () => null;

export default function ExceptionConfigTable({
  rows = [],
  isError = false,
  isLoading = false,
  isDisabled = false,
  title = '',
  error = '',
  headers = [],
  searchValue = '',
  searchQuery = '',
  errorMessage = '',
  editButtonText = '',
  inputPlaceholder = '',
  zeroStateTitle = '',
  zeroStateHelptext = '',
  zeroStateButtonText = '',
  className = '',
  onButtonClick = () => {},
  onSearch = () => {},
  onReload = () => {},
  render = DEFAULT_RENDER
}) {
  const { active, onToggle } = useToggleMap();

  const isCustomRender = render !== DEFAULT_RENDER && _isFunction(render);
  const content = isCustomRender ? (
    render()
  ) : (
    <ExceptionEntityTableRows rows={rows} active={active} onClick={onToggle} />
  );
  const hasData = isCustomRender
    ? !!content
    : _isArray(rows) && !_isEmpty(rows);

  return (
    <TableSection>
      <UiKit.Title size="md" className="mb-3">
        {title}
      </UiKit.Title>
      <If test={hasData || searchQuery}>
        <Header
          value={searchValue}
          onSearch={onSearch}
          placeholder={inputPlaceholder}
          onButtonClick={onButtonClick}
          buttonText={editButtonText}
          isDisabled={isDisabled}
        />
      </If>
      <Table className={className}>
        <TableHead headings={headers} />
        <PageErrorUi isError={isError} msg={errorMessage} onReload={onReload}>
          <TableRows>
            <TableLoader isLoading={isLoading} headers={headers}>
              <If test={hasData}>{content}</If>
              <If test={!hasData}>
                <If
                  test={!searchQuery}
                  otherwise={<TableZeroState searchQuery={searchQuery} />}
                >
                  <ZeroState
                    error={error}
                    title={zeroStateTitle}
                    helptext={zeroStateHelptext}
                    onButtonClick={onButtonClick}
                    buttonText={zeroStateButtonText}
                  />
                </If>
              </If>
            </TableLoader>
          </TableRows>
        </PageErrorUi>
      </Table>
    </TableSection>
  );
}
